import type { ReactNode } from "react";
import { cva } from "class-variance-authority";

const statementTitleVariants = cva(
  "font-semibold text-primary [text-wrap:balance]",
  {
    variants: {
      size: {
        /* Settings status headlines: 20px / 26px */
        panel: "text-appkit-headline tracking-[-0.01em]",
        /* Search hub empty states: 17px / 24px */
        empty: "text-appkit-title leading-6",
      },
    },
  },
);

/**
 * One plain sentence that states a page's status (“You’re on Pro.”), an
 * optional supporting line in the second-line color, and an optional row
 * of actions.
 */
export function PocketStatement({
  size,
  title,
  line,
  action,
  testId,
}: {
  size: "panel" | "empty";
  title: ReactNode;
  line?: ReactNode;
  action?: ReactNode;
  testId?: string;
}) {
  return (
    <div className="px-2 pb-1.5 pt-0.5" data-testid={testId}>
      <h3 className={statementTitleVariants({ size })}>{title}</h3>
      {line ? (
        <div className="mt-1 text-appkit-body text-muted [text-wrap:pretty]">
          {line}
        </div>
      ) : null}
      {action ? (
        <div className="mt-3 flex flex-wrap items-center gap-3.5">{action}</div>
      ) : null}
    </div>
  );
}
